<template>
  <section :id="`section-${section}`" class="mb-4 section-wrapper">
    <div class="section-header">
      <div class="section-header__copy">
        <p class="section-overline">Organization section</p>
        <h5 class="section-title">{{ title }}</h5>
      </div>

      <div v-if="showEdit === 'true'" class="section-actions">
        <button
          v-if="editSection !== section"
          class="btn btn-sm btn-primary"
          @click="$emit('edit', section)"
        >
          Edit
        </button>
        <div v-else class="section-actions__editing">
          <button class="btn btn-sm btn-success" @click="$emit('save', section)">Save</button>
          <button class="btn btn-sm btn-secondary" @click="$emit('cancel')">Cancel</button>
        </div>
      </div>
    </div>

    <div class="section-content">
      <slot></slot>
    </div>
  </section>
</template>

<script>
export default {
  props: ['title', 'section', 'editSection', 'showEdit'],
  emits: ['edit', 'save', 'cancel'],
};
</script>

<style lang="scss" scoped>
.section-wrapper {
  padding: 20px;
  border-radius: 20px;
  margin-bottom: 20px;
  scroll-margin-top: 24px;
}

.section-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  border-bottom: 1px solid rgba(28, 68, 38, 0.08);
  padding: 0 0 1rem;
}

.section-header__copy {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.section-overline {
  margin: 0;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #6d7d74;
}

.section-title {
  margin: 0;
}

.section-actions {
  display: flex;
  align-items: center;
}

.section-actions__editing {
  display: flex;
  gap: 0.55rem;
}

.section-content {
  padding-top: 1rem;
}

@media (max-width: 575px) {
  .section-header {
    flex-direction: column;
  }

  .section-actions,
  .section-actions__editing {
    width: 100%;
  }
}
</style>
